// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Set global BEM modifiers for enabling/disabling certain styles etc.
 * depending on certain conditions met in each function.
 * @author James Reid
 */

// @ts-check

// @@no-imports

// @@body
/**
 * Set hoverable class on document body depending on if the user is using a
 * touch device or not. Hoverable class updated on every touch event such that
 * mixed use touch/mouse devices also render correctly too, and do not show
 * hover effects after user has made a touch input.
 */
const setHoverable = () => {
    let isTouchActive = false
    const updateHoverable = () => {
        isTouchActive ? document.body.classList.remove("--hoverable")
            : document.body.classList.add("--hoverable")
    }

    document.addEventListener("touchstart", () => {
        // Activate touch then update hoverable class.
        isTouchActive = true
        updateHoverable()
    })
    document.addEventListener("mousemove", () => {
        // Update hoverable class *first* then disable touch in order to ignore
        // emulated mousemove events dispatched after touchstart or touchend
        // events.
        updateHoverable()
        isTouchActive = false
    })

    updateHoverable()
}

// @@exports
export { setHoverable }
